export const SET_CAMPAIGN_INFO = "SET_CAMPAIGN_INFO";
export const SET_USER_DATA = "SET_USER_DATA";
export const SET_PROVINCE = "SETPROVINCE";